import { GroupDetail } from '../types/groupDetail';

export const mockGroupDetails: Record<string, GroupDetail> = {
  '1': {
    id: '1',
    name: 'Youth Group',
    type: 'Youth',
    typeIcon: 'Sparkles',
    avatarUrl: '/group1.jpg',
    leader: {
      id: '1',
      name: 'John Smith',
      avatarUrl: '',
    },
    assistantLeaders: [
      { id: '2', name: 'Sarah Johnson', avatarUrl: '' },
      { id: '3', name: 'Michael Williams', avatarUrl: '' },
    ],
    address: '123 Church St, Springfield',
    areaOfTown: 'Downtown',
    meetingDay: 'Friday',
    timeOfDay: '7:00 PM',
    description: 'A vibrant community for young people to grow in faith together.',
    visibility: 'public',
    interaction: 'Full',
    status: 'Active',
    members: [
      {
        id: '1',
        name: 'John Smith',
        avatarUrl: '',
        role: 'Group Leader',
        communication: {
          receivesMessages: true,
          receivesComments: true,
          receivesWeeklySummary: true,
          receivesText: true,
          unsubscribed: false,
          noEmailAddress: false,
          ownCommSettings: false,
        },
      },
      {
        id: '2',
        name: 'Sarah Johnson',
        avatarUrl: '',
        role: 'Assistant Leader',
        communication: {
          receivesMessages: true,
          receivesComments: true,
          receivesWeeklySummary: true,
          receivesText: true,
          unsubscribed: false,
          noEmailAddress: false,
          ownCommSettings: false,
        },
      },
      {
        id: '3',
        name: 'Michael Williams',
        avatarUrl: '',
        role: 'Assistant Leader',
        communication: {
          receivesMessages: true,
          receivesComments: true,
          receivesWeeklySummary: true,
          receivesText: true,
          unsubscribed: false,
          noEmailAddress: false,
          ownCommSettings: false,
        },
      },
      {
        id: '4',
        name: 'Emily Davis',
        avatarUrl: '',
        role: 'Member',
        communication: {
          receivesMessages: true,
          receivesComments: true,
          receivesWeeklySummary: true,
          receivesText: true,
          unsubscribed: false,
          noEmailAddress: false,
          ownCommSettings: false,
        },
      },
      {
        id: '5',
        name: 'David Martinez',
        avatarUrl: '',
        role: 'Member',
        communication: {
          receivesMessages: false,
          receivesComments: false,
          receivesWeeklySummary: false,
          receivesText: false,
          unsubscribed: true,
          noEmailAddress: false,
          ownCommSettings: false,
        },
      },
      {
        id: '6',
        name: 'Jennifer Brown',
        avatarUrl: '',
        role: 'Member',
        communication: {
          receivesMessages: true,
          receivesComments: true,
          receivesWeeklySummary: false,
          receivesText: false,
          unsubscribed: false,
          noEmailAddress: true,
          ownCommSettings: false,
        },
      },
    ],
  },
  '2': {
    id: '2',
    name: 'Prayer Group',
    type: 'Prayer',
    typeIcon: 'HandHeart',
    avatarUrl: '/group2.jpg',
    leader: {
      id: '7',
      name: 'Robert Anderson',
      avatarUrl: '',
    },
    assistantLeaders: [
      { id: '8', name: 'Jessica Taylor', avatarUrl: '' },
    ],
    address: '456 Faith Ave, Springfield',
    areaOfTown: 'East Side',
    meetingDay: 'Tuesday',
    timeOfDay: '6:30 AM',
    description: 'Join us for powerful prayer sessions.',
    visibility: 'internal',
    interaction: 'Full',
    status: 'Active',
    members: [
      {
        id: '7',
        name: 'Robert Anderson',
        avatarUrl: '',
        role: 'Group Leader',
        communication: {
          receivesMessages: true,
          receivesComments: true,
          receivesWeeklySummary: true,
          receivesText: true,
          unsubscribed: false,
          noEmailAddress: false,
          ownCommSettings: false,
        },
      },
      {
        id: '8',
        name: 'Jessica Taylor',
        avatarUrl: '',
        role: 'Assistant Leader',
        communication: {
          receivesMessages: true,
          receivesComments: true,
          receivesWeeklySummary: true,
          receivesText: true,
          unsubscribed: false,
          noEmailAddress: false,
          ownCommSettings: false,
        },
      },
      {
        id: '9',
        name: 'Christopher Thomas',
        avatarUrl: '',
        role: 'Member',
        communication: {
          receivesMessages: true,
          receivesComments: true,
          receivesWeeklySummary: true,
          receivesText: true,
          unsubscribed: false,
          noEmailAddress: false,
          ownCommSettings: false,
        },
      },
      {
        id: '10',
        name: 'Amanda Moore',
        avatarUrl: '',
        role: 'Member',
        communication: {
          receivesMessages: true,
          receivesComments: true,
          receivesWeeklySummary: true,
          receivesText: false,
          unsubscribed: false,
          noEmailAddress: false,
          ownCommSettings: true,
        },
      },
    ],
  },
  '3': {
    id: '3',
    name: 'Small Group Alpha',
    type: 'Small Group',
    typeIcon: 'Users',
    avatarUrl: '/group3.png',
    leader: {
      id: '11',
      name: 'Daniel Jackson',
      avatarUrl: '',
    },
    assistantLeaders: [],
    address: '789 Community Rd, Springfield',
    areaOfTown: 'West End',
    meetingDay: 'Weekdays',
    timeOfDay: '7:30 PM',
    description: 'A small group focused on building deep relationships.',
    visibility: 'public',
    interaction: 'Full',
    status: 'Active',
    members: [
      {
        id: '11',
        name: 'Daniel Jackson',
        avatarUrl: '',
        role: 'Group Leader',
        communication: {
          receivesMessages: true,
          receivesComments: true,
          receivesWeeklySummary: true,
          receivesText: true,
          unsubscribed: false,
          noEmailAddress: false,
          ownCommSettings: false,
        },
      },
      {
        id: '12',
        name: 'Michelle White',
        avatarUrl: '',
        role: 'Member',
        communication: {
          receivesMessages: true,
          receivesComments: true,
          receivesWeeklySummary: true,
          receivesText: true,
          unsubscribed: false,
          noEmailAddress: false,
          ownCommSettings: false,
        },
      },
      {
        id: '13',
        name: 'James Harris',
        avatarUrl: '',
        role: 'Member',
        communication: {
          receivesMessages: true,
          receivesComments: false,
          receivesWeeklySummary: true,
          receivesText: true,
          unsubscribed: false,
          noEmailAddress: false,
          ownCommSettings: false,
        },
      },
      {
        id: '14',
        name: 'Lisa Martin',
        avatarUrl: '',
        role: 'Member',
        communication: {
          receivesMessages: false,
          receivesComments: false,
          receivesWeeklySummary: false,
          receivesText: false,
          unsubscribed: false,
          noEmailAddress: true,
          ownCommSettings: false,
        },
      },
    ],
  },
};

// Helper function to get group detail by ID
export const getGroupDetailById = (id: string): GroupDetail | undefined => {
  return mockGroupDetails[id];
};
